export class ConditionalPrice {
  value: boolean;
  price: number;
}
